const List = ({ ref, children, action, className, style }) => {
  return (
    <div
      style={style}
      ref={ref}
      onClick={action}
      className={`w-full scroll-hide rounded-lg shadow-lg absolute z-10 bg-neutral-light ${className}`}
    >
      <ul>{children}</ul>
    </div>
  );
};

export default List;
